module.exports = __webpack_public_path__ + "static/media/PaymentLandingScreen.41ea6681.png";